'use client'

import {
    getSkuPageTrustpilotSectionId,
    getTestimonialReviewsV2Data,
    type SkuPageTrustpilotVariant,
} from '@/lib/hardcoded-data/CategoryPages/testimonials'
import { TrustpilotReviews } from './TrustpilotReviews'

interface SkuPageTrustpilotReviewsProps {
    /** Defaults to the condition / medication / visit bank. */
    variant?: SkuPageTrustpilotVariant
}

/** Trustpilot review slider for condition, medication, visit, and lab product pages. */
export function SkuPageTrustpilotReviews({ variant = 'product' }: SkuPageTrustpilotReviewsProps) {
    const data = getTestimonialReviewsV2Data(getSkuPageTrustpilotSectionId(variant))
    if (!data?.reviews.length) return null

    return <TrustpilotReviews sectionTitle={data.title} reviews={data.reviews} />
}
